import PropTypes from 'prop-types'

import * as S from './styled'

const BankSlipInstallments = ({ paymentURL }) => (
  <S.Wrapper>
    <iframe allow="camera" src={paymentURL}></iframe>
  </S.Wrapper>
)

BankSlipInstallments.propTypes = {
  paymentURL: PropTypes.string.isRequired
}

export default BankSlipInstallments
